import * as API_TYPES from 'Utils/apiTypes';

export function validPolicyholderAge(value: string) {
  if (value === '') return false;

  const v = parseInt(value, 10);
  if (typeof v !== 'number') {
    return false;
  }
  return v >= 0 && v <= 120;
}

export function validSpouseAge(value: string) {
  if (value === '') return false;

  const v = parseInt(value, 10);
  if (typeof v !== 'number') {
    return false;
  }
  return v >= 16 && v <= 120;
}

export function validDependantAge(value: string) {
  if (value === '') return false;

  const v = parseInt(value, 10);
  if (typeof v !== 'number') {
    return false;
  }
  return v >= 0 && v <= 120;
}

export function validateMemberAge(age: string, relationship: string) {
  let validAge = true;

  if (relationship === 'policyholder') {
    validAge = validPolicyholderAge(age);
  }
  if (relationship === 'spouse') {
    validAge = validSpouseAge(age);
  } else if (relationship === 'dependent') {
    validAge = validDependantAge(age);
  }

  return validAge;
}

export function validateClaimsSummaryResponse(response: API_TYPES.ClaimsSummaryResponse) {
  // 202 is the response for "invalid_data" which can mean the POST to generate the data isn't finished
  if (response.status_code !== 200 && response.status_code !== 202) {
    throw new Error(`Unexpected status code: ${response.status_code}`);
  }

  // A 202 or a 200 with a different status, we fail this call but keep trying
  return response.status_code === 200 && response.claims_summary.status === 'ok';
}
